import ScrollableTable from "components/TableWrapper";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Button, Checkbox, Table } from "semantic-ui-react";

export default function ListTable(props: any): JSX.Element {
  const { hotel } = props;
  const [state, setState] = useState<any>({
    column: null,
    direction: null,
  });

  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (selectAll) {
      setSelectedRecords(Payments.map((item: any) => item._id));
    } else {
      setSelectedRecords([]);
    }
  }, [selectAll]);

  const {
    Payments,
    popup,
    setPopup,
    filter,
    setFilter,
    fetchCount,
    setFetchCount,
    bookingFilter,
    queryString,
    setPayment,
    selectedRecords,
    setSelectedRecords,
    voidSingle,
    setVoidSingle,
  } = props;

  useEffect(() => {
    if (Payments.length !== 0) {
      if (selectedRecords.length === Payments.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selectedRecords]);

  const data = Payments;

  const handleSort = (sortInfo: any) => {
    const { sort, column, value, direction } = sortInfo;
    if (!sort) return;

    const { type } = sort;

    if (column === value) {
      const tmp = data;
      data.splice(0, data.length, ...tmp.slice().reverse());

      setState({
        ...state,
        direction: direction === "ascending" ? "descending" : "ascending",
      });
      return;
    }

    const sortedData = data.sort((a: any, b: any) => {
      if (!b[sort.key || value] || !a[sort.key || value]) return;
      if (type === "number") return b[sort.key || value] - a[sort.key || value];
      if (type === "string")
        return b[sort.key || value].localeCompare(a[sort.key || value]);
      if (type === "date")
        return new Date(b[value]).getTime() - new Date(a[value]).getTime();
    });
    data.splice(0, data.length, ...sortedData);
    setState({ ...state, column: value, direction: "ascending" });
  };

  return (
    <ScrollableTable>
      <Table.Header>
        <Table.Row textAlign="center">
          <Table.HeaderCell width="1">
            <Checkbox
              onClick={(e: any, data: any) => {
                setSelectAll(!selectAll);
              }}
              checked={selectAll}
            />{" "}
          </Table.HeaderCell>
          <Table.HeaderCell
            sorted={state.column === "bookingNumber" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "bookingNumber" },
              })
            }
            width="2"
          >
            Booking No.
          </Table.HeaderCell>
          <Table.HeaderCell
            width="3"
            sorted={state.column === "lastName" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "lastName" },
              })
            }
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "checkInDate" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "checkInDate" },
              })
            }
          >
            Check In
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "checkInDate" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "checkOutDate" },
              })
            }
          >
            Check Out
          </Table.HeaderCell>
          {/* <Table.HeaderCell
            width="2"
            sorted={state.column === "alias" ? state.direction : null}
            onClick={() =>
              handleSort({ ...state, sort: { type: "string", value: "alias" } })
            }
          >
            Device name
          </Table.HeaderCell> */}
          <Table.HeaderCell
            width="3"
            sorted={state.column === "appcode" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "appcode" },
              })
            }
          >
            App Code
          </Table.HeaderCell>
          <Table.HeaderCell
            width="3"
            sorted={state.column === "traceNo" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "traceNo" },
              })
            }
          >
            Trace No.
          </Table.HeaderCell>
          <Table.HeaderCell
            width="3"
            sorted={state.column === "amount" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "amount" },
              })
            }
          >
            Amount (JPY)
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "createdAt" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "createdAt" },
              })
            }
          >
            Payment Date
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "settleAt" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "settleAt" },
              })
            }
          >
            Settlement Date
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "voidAt" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "voidAt" },
              })
            }
          >
            Void/Refund Date
          </Table.HeaderCell>
          <Table.HeaderCell width="3">
            <div>Actions</div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data?.length === 0 ? (
          <>no records</>
        ) : (
          data.map((item: any, i: number) => {
            const fullName = `${item?.booking?.profile?.lastName || ""} ${
              item?.booking?.profile?.firstName || ""
            }`;
            const checkInTime = dayjs(
              item?.booking?.checkInDate || ""
            ).isValid()
              ? dayjs(item?.booking?.checkInDate).format("YYYY-MM-DD HH:mm:ss")
              : "";
            const checkOutTime = dayjs(
              item?.booking?.checkOutDate || ""
            ).isValid()
              ? dayjs(item?.booking.checkOutDate).format("YYYY-MM-DD HH:mm:ss")
              : "";
            const confirmationNumber = item.bookingNumber;

            return (
              <Table.Row textAlign="center" key={i}>
                {
                  <Table.Cell>
                    <Checkbox
                      disabled={item?.voidAt}
                      checked={selectedRecords.includes(item._id)}
                      onClick={(e: any, data: any) => {
                        const { checked } = data;
                        if (checked) {
                          selectedRecords.push(item._id);
                          setSelectedRecords([...selectedRecords]);
                        } else {
                          setSelectedRecords([
                            ...selectedRecords.filter(
                              (record: any) => record !== item._id
                            ),
                          ]);
                        }
                      }}
                    />
                  </Table.Cell>
                }
                <Table.Cell>{confirmationNumber}</Table.Cell>
                <Table.Cell>
                  <div className="w-max">{fullName}</div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">{checkInTime}</div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">{checkOutTime}</div>
                </Table.Cell>
                {/* <Table.Cell>
                    <div className="w-max">{item.alias}</div>
                  </Table.Cell> */}
                <Table.Cell>
                  <div className="w-max">{item.appCode}</div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">{item.traceNo}</div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">{`$${item.amount.toLocaleString(
                    "zh-HK"
                  )}`}</div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">
                    {dayjs(item.createdAt).format("YYYY-MM-DD HH:mm")}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">
                    {item.settleAt
                      ? dayjs(item.settleAt).format("YYYY-MM-DD HH:mm")
                      : ""}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <div className="w-max">
                    {item.voidAt
                      ? dayjs(item.voidAt).format("YYYY-MM-DD HH:mm")
                      : ""}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <div className="flex justify-center gap-1">
                    <Button
                      className="w-min"
                      size="tiny"
                      color={!item?.voidAt ? "red" : undefined}
                      disabled={item?.voidAt}
                      content={item?.settleAt ? "refund" : "void"}
                      style={{ marginTop: ".5rem", padding: ".5rem" }}
                      onClick={async () => {
                        setVoidSingle((prev: boolean) => true);
                        setPayment({ ...item });
                        setPopup({ ...popup, void: true });
                      }}
                    />
                  </div>
                </Table.Cell>
              </Table.Row>
            );
          })
        )}
      </Table.Body>
    </ScrollableTable>
  );
}
